import React from "react";
import "./style.css";


export default function ModalContent({ service }) {
  return (
    <>
      <div
        className="main-modal-container"
      >
        <div className="first-side-title-container">
          <h1 className="side-title">
            {service.title}
          </h1>
        </div>
        <div
          className="first-modal-content-container"
        >
          <ul className="first-content-list">
            <h2>O que está incluso</h2>
            {service.isIncluded.map((lbl) => (
              <li key={lbl}>{lbl}</li>
            ))}
          </ul>
          <div className="divider"
          ></div>
          <ul className="first-content-list">
            <h2>O que não está incluso</h2>
            {service.isNotIncluded.map((lbl) => (
              <li key={lbl}>{lbl}</li>
            ))}
          </ul>
        </div>
      </div>
      <div
        className="main-modal-container"
      >
        <div className="first-side-title-container">
          <h1 className="side-title">
            {service.title}
          </h1>
        </div>

        <div
          className="first-modal-content-container"
          style={{flexDirection: 'column', display: 'flex', backgroundColor: 'transparent'}}
        >
          <ul className="delivery-list"
            style={{ backgroundColor: '#efefef', borderRadius: '5px'}}
          >
            <h2>O que é entregue por você</h2>
            {service.itemsDeliveredByCustomer.map((lbl) => (
              <li key={lbl}>{lbl}</li>
            ))}
          </ul>
          <div>
            {!!service.notes?.length && (
              <ul className="notes-list">
                <h2>Observações</h2>
                {service.notes.map((lbl) => (
                  <li className="notes-item" key={lbl}>{lbl}</li>
                ))}
              </ul>
            )}
            {!!service.images?.length && (
              <>
                <h2 style={{marginTop: '10%'}}>Exemplos</h2>
                <div style={{display: "flex", flexDirection: 'column', marginBottom: '20px'}}>
                  {service.images.map((img, index) => (
                    <img  style={{width: '95%', minWidth: '450px', marginLeft: '5%'}} key={index} src={img}></img>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
